
import objectPath from 'object-path'

const mutations = {
  setDictionary(state, { results, config: { target } }) {
    objectPath.set(this.state, target, results)
  },
}

export default mutations